module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cz-con"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v(_vm._s(_vm.bonusName) + " (余额" + _vm._s(_vm.bonusValue) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "alipayform",
    attrs: {
      "action": "api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253",
      "name": "transferForm",
      "method": "POST",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "msgbox"
  }, [_c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("提现金额：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reflectMoney),
      expression: "reflectMoney"
    }],
    staticClass: "input",
    staticStyle: {
      "ime-mode": "Disabled"
    },
    attrs: {
      "type": "text",
      "maxlength": "60",
      "name": "payCode"
    },
    domProps: {
      "value": (_vm.reflectMoney)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.reflectMoney = $event.target.value
      }, _vm.inputCash]
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "100",
      "margin-left": "23px",
      "color": "red"
    }
  }, [_vm._v("注：提现金额需为大于100的整数")])]), _vm._v(" "), (_vm.bonusType == '56') ? _c('p', {
    staticStyle: {
      "color": "#FF8000",
      "padding-left": "168px"
    }
  }, [_vm._v("\n                税后实际提现金额" + _vm._s(_vm.reflectMoney * 0.8) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("支付宝名称：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alipayRealName),
      expression: "alipayRealName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "disabled": _vm.userBankInfo.enterpriseAlipayAccountName ? true : false
    },
    domProps: {
      "value": (_vm.alipayRealName)
    },
    on: {
      "blur": _vm.inputAlipayRealName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alipayRealName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("支付宝账号：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alipayName),
      expression: "alipayName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "disabled": _vm.userBankInfo.enterpriseAlipayAccountNumber ? true : false
    },
    domProps: {
      "value": (_vm.alipayName)
    },
    on: {
      "blur": _vm.inputAlipayName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alipayName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("收款人：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "disabled": _vm.userBankInfo.bankUserName ? true : false
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "blur": _vm.inputName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("开户银行地区：")]), _vm._v(" "), _c('Select', {
    staticClass: "input select",
    attrs: {
      "disabled": _vm.userBankInfo.bankProvinceId > 0 ? true : false,
      "label-in-value": true,
      "size": "large",
      "placeholder": "请选择",
      "transfer": true
    },
    on: {
      "on-change": function($event) {
        return _vm.getCityList($event)
      }
    },
    model: {
      value: (_vm.provinceId),
      callback: function($$v) {
        _vm.provinceId = $$v
      },
      expression: "provinceId"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n                  ")])
  }), 1), _vm._v(" "), _c('Select', {
    staticClass: "input select",
    attrs: {
      "disabled": _vm.userBankInfo.bankCityId > 0 ? true : false,
      "label-in-value": true,
      "size": "large",
      "transfer": true
    },
    on: {
      "on-change": function($event) {
        return _vm.getBankList($event)
      }
    },
    model: {
      value: (_vm.cityId),
      callback: function($$v) {
        _vm.cityId = $$v
      },
      expression: "cityId"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("开户银行：")]), _vm._v(" "), _c('Select', {
    staticClass: "input select",
    attrs: {
      "disabled": _vm.userBankInfo.bankOpenId > 0 ? true : false,
      "label-in-value": true,
      "size": "large",
      "placeholder": "请选择开户行",
      "transfer": true
    },
    on: {
      "on-change": function($event) {
        return _vm.getBranchBankList($event)
      }
    },
    model: {
      value: (_vm.bankOpenId),
      callback: function($$v) {
        _vm.bankOpenId = $$v
      },
      expression: "bankOpenId"
    }
  }, _vm._l((_vm.bankList), function(item) {
    return _c('Option', {
      key: item.bankId,
      attrs: {
        "value": item.bankId
      }
    }, [_vm._v(_vm._s(item.bankName) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("开户银行支行：")]), _vm._v(" "), _c('Select', {
    staticClass: "input select",
    staticStyle: {
      "width": "400px !important"
    },
    attrs: {
      "filterable": "",
      "disabled": _vm.userBankInfo.branchBankOpenId > 0 ? true : false,
      "label-in-value": true,
      "size": "large",
      "placeholder": "请选择",
      "transfer": true
    },
    on: {
      "on-change": function($event) {
        return _vm.selectBranchBank($event)
      }
    },
    model: {
      value: (_vm.branchBankId),
      callback: function($$v) {
        _vm.branchBankId = $$v
      },
      expression: "branchBankId"
    }
  }, _vm._l((_vm.branchBankList), function(item) {
    return _c('Option', {
      key: item.subBranchId,
      attrs: {
        "value": item.subBranchId
      }
    }, [_vm._v(_vm._s(item.subBranchName) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("补充银行资料：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankSupplement),
      expression: "bankSupplement"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "270px"
    },
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "如银行信息缺失的请手动输入正确银行信息"
    },
    domProps: {
      "value": (_vm.bankSupplement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankSupplement = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("账号：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankUserNo),
      expression: "bankUserNo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "请填写银行卡号",
      "disabled": _vm.userBankInfo.bankUserNo ? true : false
    },
    domProps: {
      "value": (_vm.bankUserNo)
    },
    on: {
      "blur": _vm.inputBankUserNo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankUserNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("手机号：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "请填写手机号",
      "disabled": _vm.userBankInfo.phone ? true : false
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "blur": _vm.inputMobile,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("身份证号：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "请填写身份证号",
      "disabled": _vm.userBankInfo.identityCardNumber ? true : false
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "blur": _vm.inputNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, [_c('div', {
    staticClass: "demo-upload-list"
  }, [(!_vm.userBankInfo.identityCardFront) ? _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px"
    },
    attrs: {
      "show-upload-list": false,
      "on-exceeded-size": _vm.handleMaxSize,
      "on-success": _vm.handleSuccessFrontImg,
      "on-format-error": _vm.handleFormatError,
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "headers": {
        'Auth-Token': _vm.upHeaders
      },
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [(_vm.imageFrontImg) ? _c('img', {
    attrs: {
      "src": _vm.imageFrontImg
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "imageFrontImg",
      "value": "imageFrontUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "150px",
      "height": "150px",
      "line-height": "150px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userBankInfo.identityCardFront && _vm.imageFrontImg),
      expression: "!userBankInfo.identityCardFront && imageFrontImg"
    }],
    staticClass: "demo-upload-list-cover"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-eye-outline"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleView(_vm.imageFrontImg)
      }
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "ios-trash-outline"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleRemoveFrontImg()
      }
    }
  })], 1), _vm._v(" "), (_vm.userBankInfo.identityCardFront) ? _c('img', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.imageFrontImg,
      "alt": ""
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, [_c('div', {
    staticClass: "demo-upload-list"
  }, [(!_vm.userBankInfo.identityCardFront) ? _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px"
    },
    attrs: {
      "show-upload-list": false,
      "on-exceeded-size": _vm.handleMaxSize,
      "on-success": _vm.handleSuccessBackImg,
      "on-format-error": _vm.handleFormatError,
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "headers": {
        'Auth-Token': _vm.upHeaders
      },
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [(_vm.imageBackImg) ? _c('img', {
    attrs: {
      "src": _vm.imageBackImg
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "imageBackImg",
      "value": "imageBackUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "150px",
      "height": "150px",
      "line-height": "150px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userBankInfo.identityCardFront && _vm.imageFrontImg),
      expression: "!userBankInfo.identityCardFront && imageFrontImg"
    }],
    staticClass: "demo-upload-list-cover"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-eye-outline"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleView(_vm.imageBackImg)
      }
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "ios-trash-outline"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleRemoveBackImg()
      }
    }
  })], 1), _vm._v(" "), (_vm.userBankInfo.identityCardFront) ? _c('img', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.imageFrontImg,
      "alt": ""
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("验证码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payCode),
      expression: "payCode"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "6",
      "onkeyup": "this.value=this.value.replace(/\\D/g,'')",
      "onafterpaste": "this.value=this.value.replace(/\\D/g,'')"
    },
    domProps: {
      "value": (_vm.payCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payCode = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeShow),
      expression: "codeShow"
    }],
    staticClass: "code-sty",
    on: {
      "click": _vm.getCodeHandler
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeShow),
      expression: "!codeShow"
    }],
    staticClass: "code-sty grey-sty"
  }, [_vm._v(_vm._s(_vm.count) + " s")])]), _vm._v(" "), _c('p', [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageContent),
      expression: "messageContent"
    }],
    staticClass: "ivu-input bonusTextArea",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "rows": "4",
      "resize": "vertical",
      "name": "content",
      "placeholder": "",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.messageContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "yellow_btn",
    attrs: {
      "type": "button",
      "value": "确认提现"
    },
    on: {
      "click": _vm.confirmBankCash
    }
  })])])])])])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "图片预览"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [(_vm.visible) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.showImageUrl
    }
  }) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/account_logo.png"),
      "width": "200"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("身份证人像面：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("身份证国徽面：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tit"
  }, [_c('div', {
    staticClass: "tit_inner",
    staticStyle: {
      "top": "0"
    }
  }, [_vm._v("留言信息：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13d9c31c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/account-center/netStoreCash.vue
// module id = 1535
// module chunks = 1